import { Redirect, Route, Switch, useParams } from "wouter";
import { PostPage } from "./blog/PostPage";
import { ChapterPage } from "./commentary/ChapterPage";
import { CookieNotice } from "./components/CookieNotice";
import { TermPopover } from "./glossary/TermPopover";
import { About } from "./routes/About";
import { Account } from "./routes/Account";
import { Connect } from "./routes/Connect";
import { Blog } from "./routes/Blog";
import { Bibliography } from "./routes/Bibliography";
import { CommentaryIndex } from "./routes/CommentaryIndex";
import { Counseling } from "./routes/Counseling";
import { Glossary } from "./routes/Glossary";
import { Home } from "./routes/Home";
import { Login } from "./routes/Login";
import { Placeholder } from "./routes/Placeholder";
import { Privacy } from "./routes/Privacy";
import { Resources } from "./routes/Resources";
import { Stats } from "./routes/Stats";
import { useCountViews } from "./lib/stats";

/** /read/… was the plain reader; scripture now lives with the commentary on it. */
function ReadRedirect() {
  const { book, chapter } = useParams<{ book: string; chapter?: string }>();
  if (!book) return <Redirect to="/commentary" replace />;
  return <Redirect to={`/commentary/${book}${chapter ? `/${chapter}` : ""}`} replace />;
}

export function App() {
  useCountViews();
  return (
    <>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/login" component={Login} />
        <Route path="/account" component={Account} />
        <Route path="/connect" component={Connect} />
        <Route path="/stats" component={Stats} />
        <Route path="/bibliography" component={Bibliography} />
        <Route path="/glossary" component={Glossary} />
        <Route path="/counseling" component={Counseling} />
        <Route path="/commentary" component={CommentaryIndex} />
        <Route path="/commentary/:book/:chapter" component={ChapterPage} />
        <Route path="/commentary/:book" component={ChapterPage} />
        <Route path="/read/:book/:chapter" component={ReadRedirect} />
        <Route path="/read/:book" component={ReadRedirect} />
        <Route path="/read" component={ReadRedirect} />
        <Route path="/resources" component={Resources} />
        {/* …/new too: one route per section, so the page keeps its draft when a first save moves it to its address. */}
        <Route path="/resources/:slug">{() => <PostPage key="resources" section="resources" />}</Route>
        <Route path="/blog" component={Blog} />
        <Route path="/blog/:slug">{() => <PostPage key="blog" section="blog" />}</Route>
        <Route>{() => <Placeholder title="Page not found" />}</Route>
      </Switch>
      <TermPopover />
      <CookieNotice />
    </>
  );
}
